<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="accessCodes" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="accessCodeId" selectionMode="single"
  [(selection)]="accessCode" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="fs-5" [class.small-text]="reservationId">Access Codes</div>
      </div>
      <div>
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
          }

          <!--add new-->
          @if (!outlineNewButton) {
            <button pButton pRipple class="p-button-outlined"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important;" (click)="onOpenFormAdd()">New
            AccessCode +</button>
          }
          @if (outlineNewButton) {
            <button pButton pRipple class="p-button"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important;" (click)="onOpenFormAdd()">New AccessCode +</button>
          }
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'accessCodeId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'accessCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="lockLocation" [options]="lockLocations" appendTo="body"
          (onChange)="pt.filter($event.value, 'lockLocation', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="kabaStatus" [options]="accessStatuses" appendTo="body"
          (onChange)="pt.filter($event.value, 'kabaStatus', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="accessType" [options]="accessTypes" appendTo="body"
          (onChange)="pt.filter($event.value, 'accessType', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'doorName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'logger', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-accessCode let-rowIndex="rowIndex">
    <tr [pSelectableRow]="accessCode">
      <td>{{accessCode.accessCodeId}} </td>
      <td [class.bg-success]="rowIndex === 0" [class.text-white]="rowIndex === 0">{{accessCode.accessCode}}</td>
      <td>{{ formatAccessDateTime(accessCode.startDate) }}</td>
      <td>{{ formatAccessDateTime(accessCode.endDate) }}</td>
      <td>{{getLockLocationName(accessCode)}}</td>
      <td>{{getAccessStatusName(accessCode)}}</td>
      <td>{{getAccessTypeName(accessCode)}}</td>
      <td>{{accessCode.doorName}}</td>
      <td>{{accessCode.propertyCode}}</td>
      <td>{{accessCode.shortTermRentalId}}</td>
      <td>{{accessCode.reservationId}}</td>
      <td>{{accessCode.logger}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(accessCode)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>